import React, { lazy, Suspense, useEffect, useState } from "react";
import { Navigation, Pagination, Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import SubText from "components/shared/SubText";
import PayperviewService from "services/payperview/PayperviewServie";
import PayperviewFeatured from "components/skeleton/PayperviewFeatured";

const HeroCardPaperView = lazy(() => import("./HeroCardPaperView"));

const HomeTopHero = () => {
  const [isLoading, setIsLoding] = useState<any>(false);
  const [event, setEvent] = useState<any>([]);

  useEffect(() => {
    setIsLoding(true);
    PayperviewService.getAllPayperviewFeatured()
      .then((res: { data: any }) => {
        setIsLoding(false);
        setEvent(res.data);
      })
      .catch((e: any) => {
        console.log(e);
      });
  }, []);

  return (
    <div>
      {!isLoading && (
        <Suspense fallback={<PayperviewFeatured />}>
          <>
            {/* {event?.length !== 0 && (
              <SubText text={"Featured Event"} className="mb-2 font-bold" />
            )} */}

            <Swiper
              slidesPerView={1}
              spaceBetween={0}
              loop={event?.length > 1}
              autoplay={
                event?.length > 1
                  ? { delay: 5000, disableOnInteraction: false }
                  : false
              }
              modules={[Pagination, Navigation, Autoplay]}
              navigation={event?.length > 1}
              pagination={event?.length > 1 ? { clickable: true } : false}
              className="featuredEventSwiper mt-4 mb-10"
            >
              {event?.map((item: any, i: number) => (
                <SwiperSlide key={i}>
                  <HeroCardPaperView value={item} />
                </SwiperSlide>
              ))}
            </Swiper>
          </>
        </Suspense>
      )}
      {isLoading && <PayperviewFeatured />}
    </div>
  );
};

export default HomeTopHero;
